import {useCallback} from 'react';
import Dialog from "../../UI/Dialog/Dialog";
import ModalLogo from '../../KeysModals/ModalLogo';
import { IKeysModalsCommon } from '../../../store/keysTypes';
import ModalMenge from '../../KeysModals/ModalMenge';
import ModalDeleteKey from '../../KeysModals/ModalDeleteKey';
import { useKeysModal } from '../../../hooks/useKeysModal';

const KeysModalController = () => {
  const { modalName, closeModal } = useKeysModal();

  const handleCloseDialog = useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <>
      <Dialog
        open={modalName === IKeysModalsCommon.MODAL_LOGO}
        onClose={handleCloseDialog}
      >
        <ModalLogo
          onClose={handleCloseDialog}
        />
      </Dialog>

      <Dialog
        open={modalName === IKeysModalsCommon.MODAL_MENGE}
        onClose={handleCloseDialog}
      >
        <ModalMenge
          onClose={handleCloseDialog}
        />
      </Dialog>

      <Dialog
        open={modalName === IKeysModalsCommon.MODAL_DELETE_KEY}
        onClose={handleCloseDialog}
      >
        <ModalDeleteKey
          onClose={handleCloseDialog}
        />
      </Dialog>
    </>
  );
};

export default KeysModalController;
